import PageTitle from "../components/PageTitle";
import { Tabs } from "antd";
import { useSearchParams } from "react-router";
import EmployeeRequiredCourses from "../course/EmployeeRequiredCourses";
import EmployeeRequiredDpis from "../dpi/EmployeeRequiredDpis";
import EmployeeCurrentMedicalFitness from "../employee/EmployeeCurrentMedicalFitness";
import VehicleCurrentInspections from "../vehicle/VehicleCurrentInspections";
import VehicleSetupCurrentInspections from "../vehicle/VehicleSetupCurrentInspections";
import DpiCurrentInspections from "../dpi/DpiCurrentInspections";
import EquipmentCurrentInspections from "../equipment/EquipmentCurrentInspections";
import DeadlineStats from "./DeadlineStats";

export default function () {
  const [, setSearchParams] = useSearchParams();

  return (
    <>
      <PageTitle title="Dashboard" />
      <Tabs
        size={"large"}
        destroyOnHidden
        onChange={() => setSearchParams({}, { replace: true })}
        items={[
/*          { key: "overview", label: "Panoramica", children: <DeadlineStats /> },*/
          { key: "test", label: "DPI", children: <EmployeeRequiredDpis /> },
          {
            key: "courses",
            label: "Formazione",
            children: <EmployeeRequiredCourses />,
          },
          {
            key: "medicalFitness",
            label: "Idoneità",
            children: <EmployeeCurrentMedicalFitness />,
          },
          {
            key: "periodicInspections",
            label: "Verifiche periodiche",
            children: (
              <Tabs
                destroyOnHidden
                onChange={() => setSearchParams({}, { replace: true })}
                items={[
                  { key: "vehicles", label: "Mezzi", children: <VehicleCurrentInspections /> },
                  {
                    key: "vehicleSetups",
                    label: "Allestimenti",
                    children: <VehicleSetupCurrentInspections />,
                  },
                  { key: "dpi", label: "DPI", children: <DpiCurrentInspections /> },
                  {
                    key: "equipment",
                    label: "Attrezzature",
                    children: <EquipmentCurrentInspections />,
                  },
                ]}
              />
            ),
          },
        ]}
      />
    </>
  );
}
